import { Button, SizableText, colors, isWeb } from '@my/ui'
import { ReactionPopup } from '../../components'
import { ThumbsUp } from '@tamagui/lucide-icons'
import { Reaction, ReactionType, User } from 'app/types'
import { useState } from 'react'
import { useTogglePostReaction } from './commands'
import { groupPostByIdQuery } from '../../queries'

export interface GroupPostReactionsProps {
  postId?: string
  reactions?: Reaction[]
  user?: Pick<User, 'id'> | null
  activeReaction?: Reaction | undefined
  totalReactions: number
}

export const GroupPostReactionPopupContainer = (props: GroupPostReactionsProps) => {
  const [reactionsOpen, setReactionsOpen] = useState(false)
  const [mutate, { loading }] = useTogglePostReaction()

  const handleToggleReaction = (reactionType: ReactionType) => {
    if (!props.postId || !props.user?.id) {
      return
    }

    try {
      mutate({
        variables: {
          id: props.postId,
          reaction: reactionType,
        },
        onCompleted: async (data) => {
          if (!data?.toggleGroupPostReaction?.success) {
            throw new Error(data?.toggleGroupPostReaction?.message || 'Failed to toggle reaction')
          }

          setReactionsOpen(false)
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: groupPostByIdQuery.query,
            variables: {
              id: props.postId,
            },
          },
        ],
      })
    } catch (error) {
      console.error(error)
    }
  }

  // Only allow liking on native until we have proper popups
  if (!isWeb) {
    return (
      <Button
        onPress={() => handleToggleReaction('like')}
        plain
        size="$2"
        icon={<ThumbsUp size={24} color={colors.gray11} />}
        disabled={!props.user}
        loading={loading}
      >
        <SizableText color="$gray11" size="$1" fow="500">
          {props.totalReactions || 0}
        </SizableText>
      </Button>
    )
  }

  return (
    <ReactionPopup
      open={reactionsOpen}
      onOpenChange={setReactionsOpen}
      onReact={handleToggleReaction}
      activeReaction={props.activeReaction}
      trigger={
        <Button
          onPress={() => setReactionsOpen(true)}
          plain
          size="$2"
          icon={<ThumbsUp size={24} color={colors.gray11} />}
          disabled={!props.user}
          loading={loading}
        >
          <SizableText color="$gray11" size="$1" fow="500">
            {props.totalReactions || 0}
          </SizableText>
        </Button>
      }
    />
  )
}
